import md5 from 'vux/src/tools/md5/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

export const setItem = (name, val) => {
val = JSON.stringify(val);

return window.localStorage.setItem(name, val);
}
export const getItem = name => {
name = window.localStorage.getItem(name);
if(name){
name = JSON.parse(name)
}else{
name = '';
}

return name
};
export const removeItem = opt => window.localStorage.removeItem(opt);

export const getQueryString = e => {
var t = new RegExp("(^|&)" + e + "=([^&]*)(&|$)");
var a = window.location.search.substr(1).match(t);
if (a != null) return a[2];
return ""
};

export const getRect = function(el) {
if (el instanceof window.SVGElement) {
let rect = el.getBoundingClientRect()
return {
top: rect.top,
left: rect.left,
width: rect.width,
height: rect.height
}
} else {
return {
top: el.offsetTop,
left: el.offsetLeft,
width: el.offsetWidth,
height: el.offsetHeight
}
}
}
/**
* [提示框]
* @Author   lyj
* @DateTime 2018-08-08T14:49:57+0800
* @param    {{提示框}}
* @param    {[type]}                 el  [元素]
* @param    {[type]}                 txt [提示内容]
* @return   {[type]}                     [description]
*/
export const tipShow = (el,txt) =>{
el.$vux.toast.show({
text: txt,
type:'text',
isShowMask:true,
time:3000,
width:'auto',
position:'middle'
})
}

/**
* [等待框，加载中]
* @Author   lyj
* @DateTime 2018-08-08T16:04:20+0800
* @param    {{dom，this}}
* @return   {[type]}                 [description]
*/
export const showLoading = (el) => {
el.$vux.loading.show({
text: '加载中...',
position:'middle'
})
}
export const hideLoading = (el) => {
el.$vux.loading.hide()
}

export const judgeBrowser = name => {
return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
};


// WEBPACK FOOTER //
// ./src/common/js/util.js